import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
import { useState } from "react";
import toast from "react-hot-toast";
import { addTemplate } from "../../../api/admin/templateApi";

const CreateTemplates = ({ open, setOpen, setData }) => {
  const [FormData, setFormData] = useState({
    templateName: "",
    description: "",
    type: "SMS",
    templateFor: "",
    template: "",
    status: 1,
    createdAt: new Date().toISOString(),
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleCancel = () => {
    setFormData({
      templateName: "",
      description: "",
      type: "SMS",
      templateFor: "",
      template: "",
      status: 1,
      createdAt: new Date().toISOString(),
    });
    setOpen(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !FormData.templateName ||
      !FormData.description ||
      !FormData.templateFor ||
      !FormData.template
    ) {
      toast.error("Please fill all the fields");
    } else {
      addTemplate(FormData, setOpen, setFormData, setData);
    }
  };
  return (
    <>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{ minWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            Add Template
          </Typography>
          <div className="w-full space-y-3">
            <div>
              <label htmlFor="templateName">Template Name*</label>
              <input
                type="text"
                name=""
                className="w-full py-2 px-2 rounded-lg focus:outline-none border"
                placeholder="Template Name"
                id="templateName"
                onChange={handleChange}
                value={FormData.templateName}
              />
            </div>
            <div>
              <label htmlFor="description">Description*</label>
              <textarea
                type="text"
                name=""
                className="w-full py-2 px-2 rounded-lg focus:outline-none border"
                placeholder="Template Name"
                id="description"
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="type">Template Type*</label>
              <input
                disabled
                type="text"
                name=""
                id="type"
                className="w-full py-2 px-2 rounded-lg focus:outline-none border"
                value={FormData.type}
              />
            </div>
            <div>
              <label htmlFor="templateName">Template For*</label>
              <select
                name=""
                className="w-full py-2 px-2 rounded-lg focus:outline-none border"
                id="templateFor"
                onChange={handleChange}
                value={FormData.templateFor}
              >
                <option value="" className="text-black/50">
                  Select Use Case
                </option>
                <option value="Marketing">Marketing</option>
                <option value="Welcome">Welcome</option>
              </select>
            </div>
            <div>
              <label htmlFor="template">Template*</label>
              <textarea
                type="text"
                name=""
                className="w-full py-2 px-2 rounded-lg focus:outline-none border"
                placeholder="Enter your message"
                id="template"
                onChange={handleChange}
                value={FormData.template}
              />
            </div>
            <div className="flex justify-end items-center">
              <div className="flex gap-x-3">
                <AddButton onClick={handleSubmit} text="Save Now" />{" "}
                <CancelButton text="Cancel" onClick={handleCancel} />
              </div>
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default CreateTemplates;
